import React from 'react'
import PropTypes from 'prop-types'
import OverlayAttachments from './overlay-attachments'
import { formValueSelector } from 'redux-form'
import { connect } from 'react-redux'

const selector = formValueSelector('widget')

export const SendOverlayField = ({ name, overlayType, overlayMediaId }) => {
  return (
    <div className='row'>
      <OverlayAttachments
        name={name}
        overlayType={overlayType || 'OVERLAY_IMAGE'}
        overlayMediaId={overlayMediaId}
      />
    </div>
  )
}

SendOverlayField.propTypes = {
  name: PropTypes.string,
  overlayType: PropTypes.string,
  overlayMediaId: PropTypes.array
}

const SendOverlayWithKey = connect((state, props) => ({
  overlayType: selector(state, `${props.name}.overlayType`),
  overlayMediaId: selector(state, `${props.name}.overlayMediaId`)
}))(SendOverlayField)

export default SendOverlayWithKey



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/send-overlay/index.js